import { Container } from '@mui/material'
import Grid from '@mui/material/Grid2'
import { csr, leaf, mountainTrail, weather, WavePattern, Paresh, Dharti, Rani, Rajendra, Rajath, Pin } from '../../helpers/constant/imageUrl'
import './csrInitiative.scss'

const CSRInitiativeTempate = () => {
    return (
        <div className="csr-initiative">
            <div className='gradient-section'>
                <Container className='container'>
                    <Grid container alignItems={'center'}>
                        <Grid size={{ xs: 12, sm: 5 }}>
                            <h1>CSR Initiative</h1>
                            <p>Tiger Adoption to Protect Ecosystems</p>
                            <h3>Why Tiger Adoption?</h3>
                            <p>Tigers are a keystone species, crucial for maintaining the balance of the ecosystem. Protecting them helps preserve biodiversity and ensures healthy forests that support countless other species</p>
                        </Grid>
                        <Grid size={{ xs: 12, sm: 7 }} className="text-right">
                            <img src={csr} alt='map' className='map' />
                        </Grid>
                    </Grid>
                </Container>
            </div>
            <div className='economic-impact'>
                <Container className='container'>
                    <h3>Impact on the Ecosystem</h3>
                    <Grid container justifyContent="center" spacing={{ xs: 5, md: 3 }}>
                        <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                            <div className='card'>
                                <div className='hover-effect'></div>
                                <div className='icon-holder'>
                                    <img src={leaf} alt='leaf' />
                                </div>
                                <h5>Biodiversity Protection</h5>
                                <p>Tigers regulate prey populations, preventing overgrazing and ensuring plant diversity</p>
                            </div>
                        </Grid>
                        <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                            <div className='card'>
                                <div className='hover-effect'></div>
                                <div className='icon-holder'>
                                    <img src={mountainTrail} alt='mountainTrail' />
                                </div>
                                <h5>Habitat Conservation</h5>
                                <p>Protecting tigers conserves large forest areas that are home to many species</p>
                            </div>
                        </Grid>
                        <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                            <div className='card'>
                                <div className='hover-effect'></div>
                                <div className='icon-holder'>
                                    <img src={weather} alt='weather' />
                                </div>
                                <h5>Climate Benefit</h5>
                                <p>Forests where tigers live act as carbon sinks, aiding in climate change mitigation</p>
                            </div>
                        </Grid>
                    </Grid>
                </Container>
            </div>
            <div className='kumar-organic-role'>
                <div className='pattern'>
                    <img src={WavePattern} alt='WavePattern' />
                </div>
                <Container className='container'>
                    <Grid container justifyContent="space-between" alignItems={'center'}>
                        <Grid size={{ xs: 12, sm: 4 }}>
                            <h5>Kumar <span>Organic's Role</span></h5>
                        </Grid>
                        <Grid size={{ xs: 12, sm: 7 }}>
                            <p>
                                Our support goes towards anti-poaching efforts, habitat restoration, and community engagement, ensuring a sustainable future for wildlife and humans alike
                            </p>
                        </Grid>
                    </Grid>
                </Container>
            </div>
            <div className='adopted-tigers'>
                <Container className='container'>
                    <h3>Our Adopted Tigers</h3>
                    <Grid container justifyContent={'center'} columnSpacing={3} rowSpacing={10}>
                        <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                            <img src={Paresh} alt='Paresh' className='thumb' />
                            <h5>PARESH</h5>
                            <h6>
                                <img src={Pin} alt='Pin' />
                                Vadodara, Gujarat
                            </h6>
                        </Grid> 
                        <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                            <img src={Dharti} alt='DHARTI' className='thumb' />
                            <h5>DHARTI</h5>
                            <h6>
                                <img src={Pin} alt='Pin' />
                                Vadodara, Gujarat
                            </h6>
                        </Grid> 
                        <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                            <img src={Rani} alt='RANI' className='thumb' />
                            <h5>RANI</h5>
                            <h6>
                                <img src={Pin} alt='Pin' />
                                Patna, Bihar
                            </h6>
                        </Grid> 
                        <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                            <img src={Rajendra} alt='RAJENDRA' className='thumb' />
                            <h5>RAJENDRA</h5>
                            <h6>
                                <img src={Pin} alt='Pin' />
                                Bannerghatta, Bangalore
                            </h6>
                        </Grid> 
                        <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                            <img src={Rajath} alt='Rajath' className='thumb' />
                            <h5>RAJATH</h5>
                            <h6>
                                <img src={Pin} alt='Pin' />
                                Bannerghatta, Bangalore
                            </h6>
                        </Grid>                        
                    </Grid>
                </Container>
            </div>
        </div>
    )
}

export default CSRInitiativeTempate